import { useQuery } from "@apollo/react-hooks";
import { MY_DOCUMENTS_GET_UPLOADERS } from "my-documents/graphql/queries/get-my-documents-uploaders";

type Args = {
  contractCode?: string | null;
  locale: string;
};

export const useMyDocumetsUploaders = ({ contractCode, locale }: Args) => {
  const skip =
    !contractCode || (typeof contractCode === "string" && contractCode.trim() === "");

  const { data, loading, error } = useQuery(MY_DOCUMENTS_GET_UPLOADERS, {
    fetchPolicy: "cache-and-network",
    variables: skip ? undefined : { contractCode: contractCode!, locale },
    skip: skip,
  });

  return {
    data: skip ? [] : (data?.getMyDocumentsUploaders ?? []),
    loading: skip ? true : loading,
    error: skip ? undefined : error,
  };
};

export default useMyDocumetsUploaders;
